<script lang="ts">
	import InputField from '#lib/molecules/InputField.svelte'
	import Button from '#lib/atoms/Button.svelte'
	import Dialog from '#lib/atoms/Dialog.svelte'
	import { t } from '$i18n/i18n'

	type TagDialogMode = 'create' | 'edit'

	let dialog: Dialog
	let label: string = $state('')
	let mode: TagDialogMode = $state('create')
	let onSave: (label: string) => void

	const heading = $derived(
		mode === 'create' ? $t('UI.tags.dialog.create.title') : $t('UI.tags.dialog.edit.title')
	)
	const primaryButtonText = $derived(mode === 'create' ? $t('Button.create') : $t('UI.button.save'))

	export function open(
		dialogMode: TagDialogMode,
		onSaveFn: (label: string) => void,
		existingLabel: string = ''
	) {
		mode = dialogMode
		label = existingLabel
		onSave = onSaveFn
		dialog.open()
	}

	function save() {
		onSave(label)
		dialog.close()
	}
</script>

<Dialog bind:this={dialog} style="gap: 16px">
	<h3>{heading}</h3>
	<InputField
		bind:value={label}
		placeholder={$t('UI.tags.input.nameOfTag')}
		containerWidth="100%"
	/>
	<div class="edit-tag__dialog-buttons">
		<Button variant="secondary" onclick={() => dialog.close()}>{$t('Button.cancel')}</Button>
		<Button variant="primary" disabled={!label} onclick={save}>{primaryButtonText}</Button>
	</div>
</Dialog>

<style>
	.edit-tag__dialog-buttons {
		display: flex;
		gap: 8px;
		justify-content: space-between;
	}
</style>
